/* Generated by the board prep script: every image on the 'pick the look' boards. */
window.BOARD = {
 "yellow": [
  {
   "src": "yellow-01-wall-of-cans.webp",
   "label": "Wall of cans",
   "cat": "lifestyle",
   "w": 900,
   "h": 1205
  },
  {
   "src": "yellow-02-poolside-night-boxes.webp",
   "label": "Poolside at night",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-03-hands-full.webp",
   "label": "Hands full",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "yellow-04-cooler-shelf.webp",
   "label": "Cooler shelf",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-05-condensation-flatlay.webp",
   "label": "Cold flatlay",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "yellow-06-turf-boxes.webp",
   "label": "Boxes on the field",
   "cat": "packaging",
   "w": 900,
   "h": 900
  },
  {
   "src": "yellow-07-court-pyramid.webp",
   "label": "Court pyramid",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "yellow-08-fruit-fridge.webp",
   "label": "Fruit fridge",
   "cat": "lifestyle",
   "w": 781,
   "h": 1400
  },
  {
   "src": "yellow-09-ledge-low-angle.webp",
   "label": "Low-angle ledge",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-10-blue-basket.webp",
   "label": "Market basket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-11-fridge-door-hand.webp",
   "label": "Fridge door grab",
   "cat": "lifestyle",
   "w": 900,
   "h": 1205
  },
  {
   "src": "yellow-01-red-basket.webp",
   "label": "Grocery basket",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-02-denim-hug.webp",
   "label": "Denim hug",
   "cat": "lifestyle",
   "w": 900,
   "h": 725
  },
  {
   "src": "yellow-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-04-armful.webp",
   "label": "An armful",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-05-warehouse.webp",
   "label": "Warehouse stack",
   "cat": "packaging",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-06-banana-pile.webp",
   "label": "Banana pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-07-pool-float.webp",
   "label": "Pool float",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "yellow-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-x00.webp",
   "label": "Store endcap",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-x01.webp",
   "label": "Cooler doors",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-x02.webp",
   "label": "Shelf close-up",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-x03.webp",
   "label": "Floor shipper",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-x04.webp",
   "label": "Cafe grab-and-go",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-x05.webp",
   "label": "12-can box",
   "cat": "packaging",
   "w": 900,
   "h": 672
  },
  {
   "src": "yellow-x11.webp",
   "label": "Studio light",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-x12.webp",
   "label": "Splash",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-x13.webp",
   "label": "Softball bleachers",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-x14.webp",
   "label": "Pool day",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "yellow-x15.webp",
   "label": "The lineup",
   "cat": "packaging",
   "w": 900,
   "h": 1125
  }
 ],
 "cream": [
  {
   "src": "cream-01-wall-of-cans.webp",
   "label": "Wall of cans",
   "cat": "lifestyle",
   "w": 900,
   "h": 1205
  },
  {
   "src": "cream-02-poolside-night-boxes.webp",
   "label": "Poolside at night",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-03-hands-full.webp",
   "label": "Hands full",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "cream-04-cooler-shelf.webp",
   "label": "Cooler shelf",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-05-condensation-flatlay.webp",
   "label": "Cold flatlay",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "cream-06-turf-boxes.webp",
   "label": "Boxes on the field",
   "cat": "packaging",
   "w": 900,
   "h": 900
  },
  {
   "src": "cream-07-court-pyramid.webp",
   "label": "Court pyramid",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "cream-08-fruit-fridge.webp",
   "label": "Fruit fridge",
   "cat": "lifestyle",
   "w": 781,
   "h": 1400
  },
  {
   "src": "cream-09-ledge-low-angle.webp",
   "label": "Low-angle ledge",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-10-blue-basket.webp",
   "label": "Market basket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-11-fridge-door-hand.webp",
   "label": "Fridge door grab",
   "cat": "lifestyle",
   "w": 900,
   "h": 1205
  },
  {
   "src": "cream-01-red-basket.webp",
   "label": "Grocery basket",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-02-denim-hug.webp",
   "label": "Denim hug",
   "cat": "lifestyle",
   "w": 900,
   "h": 725
  },
  {
   "src": "cream-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-04-armful.webp",
   "label": "An armful",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-05-warehouse.webp",
   "label": "Warehouse stack",
   "cat": "packaging",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-06-banana-pile.webp",
   "label": "Banana pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-07-pool-float.webp",
   "label": "Pool float",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "cream-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-x00.webp",
   "label": "Store endcap",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-x01.webp",
   "label": "Cooler doors",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-x02.webp",
   "label": "Shelf close-up",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-x03.webp",
   "label": "Floor shipper",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-x04.webp",
   "label": "Cafe grab-and-go",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-x05.webp",
   "label": "12-can box",
   "cat": "packaging",
   "w": 900,
   "h": 672
  },
  {
   "src": "cream-x06.webp",
   "label": "The lineup",
   "cat": "packaging",
   "w": 900,
   "h": 1125
  },
  {
   "src": "cream-x07.webp",
   "label": "Kitchen pour",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "cream-x08.webp",
   "label": "After the run",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ],
 "vertical": [
  {
   "src": "vertical-01-wall-of-cans.webp",
   "label": "Wall of cans",
   "cat": "lifestyle",
   "w": 900,
   "h": 1205
  },
  {
   "src": "vertical-02-poolside-night-boxes.webp",
   "label": "Poolside at night",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "vertical-03-hands-full.webp",
   "label": "Hands full",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "vertical-04-cooler-shelf.webp",
   "label": "Cooler shelf",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "vertical-05-condensation-flatlay.webp",
   "label": "Cold flatlay",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "vertical-06-turf-boxes.webp",
   "label": "Boxes on the field",
   "cat": "packaging",
   "w": 900,
   "h": 900
  },
  {
   "src": "vertical-07-court-pyramid.webp",
   "label": "Court pyramid",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "vertical-08-fruit-fridge.webp",
   "label": "Fruit fridge",
   "cat": "lifestyle",
   "w": 781,
   "h": 1400
  },
  {
   "src": "vertical-09-ledge-low-angle.webp",
   "label": "Low-angle ledge",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "vertical-10-blue-basket.webp",
   "label": "Market basket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "vertical-11-fridge-door-hand.webp",
   "label": "Fridge door grab",
   "cat": "lifestyle",
   "w": 900,
   "h": 1205
  },
  {
   "src": "vertical-01-red-basket.webp",
   "label": "Grocery basket",
   "cat": "retail",
   "w": 900,
   "h": 1117
  },
  {
   "src": "vertical-02-denim-hug.webp",
   "label": "Denim hug",
   "cat": "lifestyle",
   "w": 900,
   "h": 725
  },
  {
   "src": "vertical-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "vertical-04-armful.webp",
   "label": "An armful",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "vertical-05-warehouse.webp",
   "label": "Warehouse stack",
   "cat": "packaging",
   "w": 900,
   "h": 1117
  },
  {
   "src": "vertical-06-banana-pile.webp",
   "label": "Banana pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "vertical-07-pool-float.webp",
   "label": "Pool float",
   "cat": "lifestyle",
   "w": 900,
   "h": 1342
  },
  {
   "src": "vertical-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "vertical-x00.webp",
   "label": "The lineup",
   "cat": "packaging",
   "w": 900,
   "h": 672
  }
 ],
 "d4": [
  {
   "src": "d4-06-banana-pile.webp",
   "label": "On the pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d4-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d4-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ],
 "d5": [
  {
   "src": "d5-06-banana-pile.webp",
   "label": "On the pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d5-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d5-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ],
 "d6": [
  {
   "src": "d6-06-banana-pile.webp",
   "label": "On the pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d6-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d6-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ],
 "d7": [
  {
   "src": "d7-06-banana-pile.webp",
   "label": "On the pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d7-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d7-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ],
 "d8": [
  {
   "src": "d8-06-banana-pile.webp",
   "label": "On the pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d8-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d8-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ],
 "d9": [
  {
   "src": "d9-06-banana-pile.webp",
   "label": "On the pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d9-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d9-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ],
 "d10": [
  {
   "src": "d10-06-banana-pile.webp",
   "label": "On the pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d10-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d10-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ],
 "d11": [
  {
   "src": "d11-06-banana-pile.webp",
   "label": "On the pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d11-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d11-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ],
 "d12": [
  {
   "src": "d12-06-banana-pile.webp",
   "label": "On the pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d12-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d12-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ],
 "d13": [
  {
   "src": "d13-06-banana-pile.webp",
   "label": "On the pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d13-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d13-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ],
 "d14": [
  {
   "src": "d14-06-banana-pile.webp",
   "label": "On the pile",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d14-03-back-pocket.webp",
   "label": "Back pocket",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  },
  {
   "src": "d14-08-ice-cooler.webp",
   "label": "Ice cooler",
   "cat": "lifestyle",
   "w": 900,
   "h": 1117
  }
 ]
};
